import type { DividerComponent } from "../../types";

/**
 * Visible horizontal separator between blocks — a slate rule or three brand
 * dots, full-width or short-centred. Complements the invisible Margin spacer.
 */
export function DividerRenderer({ component }: { component: DividerComponent }) {
  const content = component.content ?? ({} as DividerComponent["content"]);
  const variant = content.variant === "points" ? "points" : "ligne";
  const short = content.width === "short";

  if (variant === "points") {
    return (
      <section data-divider="points">
        <div className="flex items-center justify-center gap-2" aria-hidden="true">
          <span className="h-1.5 w-1.5 rounded-full bg-[#005CA9]/60" />
          <span className="h-1.5 w-1.5 rounded-full bg-[#005CA9]/60" />
          <span className="h-1.5 w-1.5 rounded-full bg-[#005CA9]/60" />
        </div>
      </section>
    );
  }

  return (
    <section data-divider="ligne">
      <hr className={`border-t border-slate-200 ${short ? "mx-auto w-24" : "w-full"}`} />
    </section>
  );
}
